import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const services = ["WordPress Design", "SEO Optimization", "Google Business Profile", "Social Media Growth", "Content Creation", "Video Editing", "Client Training", "Premium Hosting", "Brand Development", "Digital Strategy", "Growth Partnerships"];
  const navLinks = [{
    label: "Home",
    to: "/HomePage"
  }, {
    label: "Services",
    to: "/ServicesPage"
  }, {
    label: "About",
    to: "/AboutPage"
  }, {
    label: "Contact",
    to: "/ContactPage"
  }];
  return <section data-section-id="27619" id="footer" className="dark bg-background text-foreground pt-20 pb-8 border-t border-primary/40">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-10 mb-16">
          <div className="max-w-lg">
            <Link to="/HomePage" className="block mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/rpg-studios-logo.png" alt="RPG-Studios Logo" className="h-10 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              RPG-Studios is a premium digital agency dedicated to building long-term relationships, not just businesses. Based in Quitman, GA, we help our partners scale their online presence through expert design, SEO, and strategic growth management.
            </p>
            <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              <Link to="/ContactPage">
                Start Your Growth Journey <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        <Separator className="bg-primary/10 mb-16" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-serif font-bold tracking-tight text-lg">Navigation</h3>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link, i) => <Link key={i} data-index={i} to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit flex items-center gap-2 group">
                  <span className="h-1 w-1 rounded-full bg-primary/50 opacity-0 transition-opacity group-hover:opacity-100" />
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6 lg:col-span-2">
            <h3 className="text-foreground font-serif font-bold tracking-tight text-lg">Our Services</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/ServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit block">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-serif font-bold tracking-tight text-lg">Contact Us</h3>
            <div className="flex flex-col gap-5">
              <div className="flex items-start gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <MapPin className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm leading-relaxed mt-1 group-hover:text-foreground transition-colors">
                  Quitman, GA
                </span>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <Phone className="h-5 w-5 text-primary" />
                </div>
                <Link to="tel:+12293291016" className="text-sm hover:text-primary transition-colors">
                  (229) 329-1016
                </Link>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <Link to="mailto:sales@rpg-studios.com" className="text-sm hover:text-primary transition-colors">
                  sales@rpg-studios.com
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-primary/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-muted-foreground">
          <p className="text-center md:text-left">
            &copy; {currentYear} RPG-Studios. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4">
            <Link to="#" aria-label="Facebook" className="bg-primary/5 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              <Facebook className="h-4 w-4" />
            </Link>
            <Link to="#" aria-label="Instagram" className="bg-primary/5 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              <Instagram className="h-4 w-4" />
            </Link>
            <Link to="#" aria-label="LinkedIn" className="bg-primary/5 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300">
              <Linkedin className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}